import React from 'react';

function CircleCheck2(props) {
	return (
		<svg height="18" width="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000">
		<path d="M11.42 3.18a6.33 6.33 0 1 0 3.91 5.24" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
		<path d="M6.33 7.83l3.02 3.02 6.02-7.54" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
	</g>
</svg>
	);
};

export default CircleCheck2;